import { useState, useEffect } from "react";

/**
 * Returns `intervalMs` when the tab is visible, `0` when hidden.
 * RTK Query treats `pollingInterval: 0` as "no polling", so this
 * effectively pauses polls for background tabs and resumes + refetches
 * immediately when the user switches back.
 */
export function usePollingInterval(intervalMs: number): number {
  const [visible, setVisible] = useState(!document.hidden);

  useEffect(() => {
    const handler = () => setVisible(!document.hidden);
    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  }, []);

  return visible ? intervalMs : 0;
}
